

import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.setSeoMeta();
    this.setSchema();
  }

  setSeoMeta() {
    this.titleService.setTitle($localize`:@@PRIVACY_POLICY.TITLE:Privacy Policy | Medeil - Secure Pharmacy & Retail Data Management`);

    this.metaService.updateTag({
      name: 'description',
      content: $localize`:@@PRIVACY_POLICY.DESCRIPTION:Discover how Medeil ensures the privacy and security of your Pharmacy & Retail data.`
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: $localize`:@@PRIVACY_POLICY.KEYWORDS:Medeil Privacy Policy, Healthcare data privacy, Secure patient data management, Data protection in healthcare, GDPR compliance for healthcare, HIPAA-compliant software, Data collection and usage policy`
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: $localize`:@@PRIVACY_POLICY.OG_TITLE:Privacy Policy | Medeil`
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: $localize`:@@PRIVACY_POLICY.OG_DESCRIPTION:Discover how Medeil ensures the privacy and security of your Pharmacy & Retail data.`
    });

    this.metaService.updateTag({
      property: 'og:url',
      content: 'https://www.medeil.com/privacy-policy'
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website'
    });
  }

  setSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": $localize`:@@PRIVACY_POLICY.SCHEMA_NAME:Privacy Policy`,
      "url": "https://www.medeil.com/privacy-policy",
      "description": $localize`:@@PRIVACY_POLICY.SCHEMA_DESCRIPTION:Discover how Medeil ensures the privacy and security of your Pharmacy & Retail data.`,
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
      }
    };

    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }
}





// import { Component, OnInit } from '@angular/core';
// import { Meta, Title } from '@angular/platform-browser';

// @Component({
//   selector: 'app-privacy-policy',
//   templateUrl: './privacy-policy.component.html',
//   styleUrls: ['./privacy-policy.component.scss']
// })
// export class PrivacyPolicyComponent implements OnInit {
//   constructor(private titleService: Title, private metaService: Meta) {}

//   ngOnInit(): void {
//     this.setSeoMeta();
//     this.setSchema();
//   }

//   setSeoMeta() {
//     this.titleService.setTitle('Privacy Policy | Medeil - Secure Pharmacy & Retail Data Management');
//     this.metaService.updateTag({ name: 'description', content: 'Discover how Medeil ensures the privacy and security of your Pharmacy & Retail data. Our Privacy Policy explains how we collect, use, and protect your information in compliance with global healthcare standards.' });
//     this.metaService.updateTag({ name: 'keywords', content: 'Medeil Privacy Policy, Healthcare data privacy, Secure patient data management, Data protection in healthcare, GDPR compliance for healthcare, HIPAA-compliant software, Data collection and usage policy' });
//     this.metaService.updateTag({ property: 'og:title', content: 'Privacy Policy | Medeil' });
//     this.metaService.updateTag({ property: 'og:description', content: 'Discover how Medeil ensures the privacy and security of your Pharmacy & Retail data.' });
//     this.metaService.updateTag({ property: 'og:url', content: 'https://www.medeil.com/privacy-policy' });
//     this.metaService.updateTag({ property: 'og:type', content: 'website' });
//   }

//   setSchema() {
//     const schema = {
//       "@context": "https://schema.org",
//       "@type": "WebPage",
//       "name": "Privacy Policy",
//       "url": "https://www.medeil.com/privacy-policy",
//       "description": "Discover how Medeil ensures the privacy and security of your Pharmacy & Retail data.",
//       "publisher": {
//         "@type": "Organization",
//         "name": "Medeil",
//         "url": "https://www.medeil.com",
//         "logo": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
//       }
//     };

//     const script = document.createElement('script');
//     script.setAttribute('type', 'application/ld+json');
//     script.textContent = JSON.stringify(schema);
//     document.head.appendChild(script);
//   }
// }

